import { Component, OnInit, Input, Inject, HostListener, ViewChild, EventEmitter, Output } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BsDropdownContainerComponent } from 'ngx-bootstrap/dropdown';
/**
 * Font Size - Allow user to increase/decrease font size
 */
@Component({
  selector: 'app-font-size',
  templateUrl: './font-size.component.html',
  styleUrls: ['./font-size.component.scss'],
})
export class FontSizeComponent implements OnInit {
  /**
   * indicate if dropdown has to be aligned right
   */
  @Input() isRightAlign = true;

  /**
   * anchor link css class
   */
  @Input() aLinkCss = '';

  /**
   * dropdown align css class
   */
  @Input() dropdownAlignCss = '';

  /**
   * other dropdown element to hide
   */
  @Input() dropdownEle;

  /**
   * reference to dropdownComponent
   */
  @ViewChild('fontSizeDropdown') fontSizeDropdown: BsDropdownContainerComponent;

  /**
   * emit event when font size dropdown has been clicked
   */
  @Output() fontSizeDropdownClick = new EventEmitter();

  /**
   * constructor to inject dependency
   * @param document instance of document
   */

  constructor(@Inject(DOCUMENT) private document: Document) {}

  /**
   * initialize component
   */
  ngOnInit() {}

  /**
   * apply anchor tag css class
   */
  applyAnchorCss() {
    return this.aLinkCss;
  }

  /**
   * apply dropdown alignment css class
   */
  applyDropdownAlignClass() {
    return this.dropdownAlignCss;
  }

  /**
   * set font size on body tag
   * @param fontSize fontsize selected by user
   */
  setFontSize(fontSize) {
    this.document.body.classList.remove('small', 'normal', 'large');
    this.document.body.classList.add(fontSize);
  }

  /**
   * on font size dropdown change
   * @returns false
   */
  dropdownClick() {
    if (this.dropdownEle) {
      this.dropdownEle.isOpen = false;
    }
    this.fontSizeDropdownClick.emit();
    return false;
  }
}
